<template>
<div class="sidebar"  v-if="!$parent.isAdminPage($route.path, $route.name)">
      <nav class="sidebar-nav">
          <ul class="nav">
              <li class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                  <router-link to="/dashboard?page=1" exact class="nav-link">
                      <i class="icon-speedometer"></i> Employee Dashboard
                  </router-link>
              </li>

              <li class="nav-item nav-dropdown" :class="{'open': isActiveMenuGroup(reports_paths)}" v-if="userinfo.is_approver === 1">
                <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/user-tasks)')}">
                  <router-link :to="{path: '/time-sheets/approval', query: {page: 1}}" class="nav-link">
                      <i class="fa fa-tasks"></i> Time Sheet Approval
                  </router-link>
                </li>
              </li>

              <li class="nav-item" :class="{'active-menu': isActiveMenu('(time-sheets/all)')}" v-if="is_director">
                    <router-link to="/time-sheets/all?page=1" exact class="nav-link">
                        <i class="icon-speedometer"></i> All Timesheets
                    </router-link>
                </li>

              <li class="nav-item nav-dropdown" :class="{'open': isActiveMenuGroup(reports_paths)}" v-if="permissions.indexOf('reports_read') >= 0 && userinfo.is_approver === 1">

                <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-area-chart"></i>Time Sheet Reports</a>
                <ul class="nav-dropdown-items">
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(reports/user-tasks)')}">
                        <router-link :to="{path: '/time-sheets-report', query: {page: 1}}" class="nav-link">
                            <i class="fa fa-tasks"></i> Aggregated Report
                        </router-link>
                    </li>
                    <li  class="nav-item" :class="{'active-menu': isActiveMenu('(reports/user-tasks)')}">
                        <router-link :to="{path: '/time-sheets-report/detailed-report', query: {page: 1}}" class="nav-link">
                            <i class="fa fa-tasks"></i> Detailed Report
                        </router-link>
                    </li>
                    <li  class="nav-item" :class="{'active-menu': isActiveMenu('(reports/user-tasks)')}">
                        <router-link :to="{path: '/time-sheets-report/monthly-pdf-report', query: {page: 1}}" class="nav-link">
                            <i class="fa fa-tasks"></i> Monthly PDF Report
                        </router-link>
                    </li>
                </ul>
            </li>

              <li class="nav-item nav-dropdown" :class="{'open': isActiveMenuGroup(settings_paths)}" v-if="permissions.indexOf('reports_read') >= 0 && userinfo.is_approver === 1" >
                  <a href="#" class="nav-link nav-dropdown-toggle"><i class="icon-wrench"></i>User Management</a>
                  <ul class="nav-dropdown-items">

                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(users)')}">
                      <router-link :to="{path: '/users?page=1'}" class="nav-link">
                          <i class="fa fa-cog"></i> Users
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(categories)')}">
                      <router-link :to="{path: '/categories?page=1'}" class="nav-link">
                          <i class="fa fa-cog"></i> Manage Category
                      </router-link>
                    </li>
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(contracttype)')}">
                      <router-link :to="{path: '/contracttype?page=1'}" class="nav-link">
                          <i class="fa fa-cog"></i> Contract Types
                      </router-link>
                    </li>

                  </ul>
              </li>

          </ul>
      </nav>
    </div>
</template>
 
<script>
import _ from 'lodash'
export default {
  data () {
    return {
      permissions: (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')).permissions : [],
      transaction_paths: ['/time-tasks', '/workflow', '/workflow/all-my-tasks'],
      reports_paths: ['/reports/user-tasks', '/reports/completed-tasks', '/reports/client-revenue', '/reports/weekly-time'],
      settings_paths: ['/settings', '/users', '/roles', '/fee-types', '/task-types', '/checklists'],
      userinfo: (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')) : [],
      roles: (this.$cookies.isKey('op_session_roles')) ? JSON.parse(this.$cookies.get('op_session_roles')) : [],
      is_director: false
    }
  },
  beforeCreate () {
    this.permissions = (this.$cookies.isKey('op_session_content')) ? JSON.parse(this.$cookies.get('op_session_content')).permissions : []
  },
  created () {
    var vue = this
    console.log('this.roles')
    console.log(this.roles)
    _.each(this.roles, function (item) {
      if (item.name === 'Director') {
        vue.is_director = true
      }
    })
  },
  methods: {
    isActiveMenuGroup (menuitems = []) {
      for (var i in menuitems) {
        let pattern = new RegExp(menuitems[i])
        if (pattern.test(this.$route.path)) {
          return true
        }
      }
    },
    isActiveMenu (path) {
      var pattern = new RegExp(path)
      if (path === '/workflow' || path === '/workflow/all-my-tasks') {
        return path === this.$route.path
      } else {
        return pattern.test(this.$route.path)
      }
    }
  }
}
</script>
<style>
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu {
        background: #03BFA5 !important;
    }
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu a:hover {
        background: #04d1b2 !important;
    }
</style>


// WEBPACK FOOTER //
// Sidebar.vue?3d94cc03